import { useState, useEffect } from "react";

const useDebounce = (value, delay) => {
    const [debounceValue, setDebounceValue] = useState(value)

    useEffect(() => {
        // start a timer
        
        const handle = setTimeout(() => {
            setDebounceValue(value)
        }, delay);

        return () => {
            
            clearTimeout(handle)
        }
    }, [value, delay])
    return debounceValue
}

export default useDebounce;